export const FETCH_LOCATIONS = 'vt//FETCH_LOCATIONS';
export const FETCH_LOCATIONS_SUCCESS = 'vt//FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE = 'vt//FETCH_LOCATIONS_FAILURE';

export const ADD_LOCATION = 'vt//ADD_LOCATION';
export const ADD_LOCATION_SUCCESS = 'vt//ADD_LOCATION_SUCCESS';
export const ADD_LOCATION_FAILURE = 'vt//ADD_LOCATION_FAILURE';

export const EDIT_LOCATION = 'vt//EDIT_LOCATION';
export const EDIT_LOCATION_SUCCESS = 'vt//EDIT_LOCATION_SUCCESS';
export const EDIT_LOCATION_FAILURE = 'vt//EDIT_LOCATION_FAILURE';

export const DELETE_LOCATION = 'vt//DELETE_LOCATION';
export const DELETE_LOCATION_SUCCESS = 'vt//DELETE_LOCATION_SUCCESS';
export const DELETE_LOCATION_FAILURE = 'vt//DELETE_LOCATION_FAILURE';

export const FETCH_DRAWERS = 'vt//FETCH_DRAWERS';
export const FETCH_DRAWERS_SUCCESS = 'vt//FETCH_DRAWERS_SUCCESS';
export const FETCH_DRAWERS_FAILURE = 'vt//FETCH_DRAWERS_FAILURE';

export const action = <T>(type: string, payload?: T): IAction => ({
  type,
  payload,
});

export const actionSuccess = <T>(type: string, payload: T): IAction => ({
  type: `${type}_SUCCESS`,
  payload,
});

export const actionFailure = <T>(type: string, payload: T): IAction => ({
  type: `${type}_FAILURE`,
  payload,
});
